export default "__VITE_ASSET__DHfDqAqA__"